import * as R from 'ramda';
import { DetailsModalEntity, ProductDetailsEntityType } from '../types/productDetails.types';

interface ResolveSuggestedProductsCustomersParams {
  isStore: boolean;
  customerIds: string[];
  modalCustomerId?: string;
}

interface SuggestedProductsCustomers {
  customerIds: string[];
  hasCustomer: boolean;
}

export const getAllProductColorIds = (entity?: DetailsModalEntity) => {
  if (entity?.type !== ProductDetailsEntityType.PRODUCT) {
    return [];
  }

  return entity.data.allColors.map((color) => color.productColorId);
};

export const resolveSuggestedProductsCustomers = ({
  isStore,
  customerIds,
  modalCustomerId,
}: ResolveSuggestedProductsCustomersParams): SuggestedProductsCustomers => {
  const hasCustomer = !!modalCustomerId || !R.isEmpty(customerIds) || isStore;

  if (isStore) {
    return { customerIds: [], hasCustomer };
  }

  if (!R.isEmpty(customerIds)) {
    return { customerIds, hasCustomer };
  }

  return { customerIds: modalCustomerId ? [modalCustomerId] : [], hasCustomer };
};

export const hasVisibleText = (value?: string | null): value is string => !!value?.trim();
